import MapPositionController from './map-position.controller';

const MapPositionComponent = {
    selector: 'sbMapPosition',
    template: require('./map-position.html'),
    controller: MapPositionController,
    bindings: {
        thing: '<',
    },
};

export default MapPositionComponent;



// WEBPACK FOOTER //
// ./src/app/detail/map-position/index.js